import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { catchError, shareReplay } from "rxjs/operators";
import { Curso } from "src/app/_models/curso";
import { environment } from 'src/environments/environment';

const API_URL = `${environment.apiUrl}/api`;


@Injectable({providedIn: 'root'})
export class AsistenciaListaCursosService {

  private errorMsgeBS = new BehaviorSubject<string>("");
  errorMsge$ = this.errorMsgeBS.asObservable();

  private loadingBS = new BehaviorSubject(false);
  loading$ = this.loadingBS.asObservable();

  curso$ = this.http.get<Curso[]>(`${API_URL}/Cursos/true`)
  .pipe(
    shareReplay(1),
    catchError((err) => {
      this.errorMsgeBS.next(err);
      return EMPTY;
    })
  );


  constructor(private http:HttpClient) { }

}
